import _get from 'lodash/get';
import _property from 'lodash/property'; // Constants

import { EMPTY_OBJECT, EMPTY_ARRAY } from '../app.constants';

var brand = _property('brand');

var billingAddress = _property('billingAddress');

var billingSameAsShipping = _property('billingSameAsShipping');

var companyid = _property('companyId');

var createdTime = _property('createdTime');

var dealerId = _property('dealerId');

var deleted = _property('deleted');

var estimatedDeliveryTime = _property('estimateDeliveryTime'); // since in BE key is estimateDeliveryTime


var id = _property('id');

var routeId = _property('routeId');

var modifiedTime = _property('modifiedTime');

var poAssetType = _property('orderType');

var poNumber = _property('orderNumber');

var poNumberMinimal = _property('orderNo');

var requestedByUserId = _property('requestedByUserId');

var shippingAddress = _property('shippingAddress');

var shippingSameAsBilling = _property('shippingSameAsBilling');

var status = _property('status');

var userId = _property('userId');

var vendorEmail = _property('vendorDetails.vendorEmail');

var vendorId = _property('vendorDetails.vendorId');

var vendorSiteId = _property('vendorDetails.vendorSiteId');

var vendorDesc = function vendorDesc() {
  var vendorDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  return vendorDetails.vendorName || vendorDetails.temporaryVendorName;
};

var vendorPhone = _property('vendorDetails.vendorPhone');

var tempVendorName = _property('vendorDetails.temporaryVendorName');

var vendorDetails = _property('vendorDetails');

var universalId = _property('universalId');

var totalAmount = _property('totalAmount');

var dueAmount = _property('dueAmount');

var controlNumber = _property('controlNumber');

var subletType = _property('assetType');

var subletOpcode = _property('subletOpcodeDetail.opcode');

var refOrderId = _property('refOrderId');

var refOrderType = _property('refOrderType');

var creditPOParts = _property('parts');

var additional = _property('additional');

var summary = _property('summary');

var creditPORequestedBy = _property('requestedBy');

var purchaseOrderId = _property('purchaseOrderId');

var siteId = _property('siteId');

var mode = _property('mode');

var description = _property('description');

var taxDetails = _property('taxDetails');

var taxRegime = _property('taxRegime');

var taxBreakUp = _property('taxBreakUp');

var flatTaxApplied = _property('flatTaxApplied');

var getParts = function getParts(purchaseOrder) {
  return _get(purchaseOrder, 'partPurchaseDetails') || EMPTY_ARRAY;
}; // OEM  properties


var oemParts = _property('oemParts');

var filterCancelledQuantity = _property('filterCancelledQuantity');

var includeInOnOrder = _property('considerForDailyOrderReport');

var creationMode = _property('creationMode');

var READER = {
  brand: brand,
  billingAddress: billingAddress,
  billingSameAsShipping: billingSameAsShipping,
  companyid: companyid,
  createdTime: createdTime,
  dealerId: dealerId,
  deleted: deleted,
  estimatedDeliveryTime: estimatedDeliveryTime,
  id: id,
  modifiedTime: modifiedTime,
  parts: getParts,
  poAssetType: poAssetType,
  poNumber: poNumber,
  poNumberMinimal: poNumberMinimal,
  requestedByUserId: requestedByUserId,
  shippingAddress: shippingAddress,
  shippingSameAsBilling: shippingSameAsBilling,
  status: status,
  userId: userId,
  vendorEmail: vendorEmail,
  vendorId: vendorId,
  vendorPhone: vendorPhone,
  vendorSiteId: vendorSiteId,
  vendorDesc: vendorDesc,
  tempVendorName: tempVendorName,
  vendorDetails: vendorDetails,
  routeId: routeId,
  universalId: universalId,
  totalAmount: totalAmount,
  dueAmount: dueAmount,
  controlNumber: controlNumber,
  oemParts: oemParts,
  subletType: subletType,
  subletOpcode: subletOpcode,
  refOrderType: refOrderType,
  refOrderId: refOrderId,
  creditPOParts: creditPOParts,
  additional: additional,
  summary: summary,
  creditPORequestedBy: creditPORequestedBy,
  purchaseOrderId: purchaseOrderId,
  siteId: siteId,
  mode: mode,
  filterCancelledQuantity: filterCancelledQuantity,
  includeInOnOrder: includeInOnOrder,
  description: description,
  taxDetails: taxDetails,
  taxRegime: taxRegime,
  taxBreakUp: taxBreakUp,
  flatTaxApplied: flatTaxApplied,
  creationMode: creationMode
};
export default READER;